<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Inspections'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-row class="extra-bottom-padding">
      <tidy-text [header]="'How do you want to perform inspections?'" />
    </tidy-row>

    <tidy-row class="extra-bottom-padding">
      @for (template of inspectionTemplates; track template) {
        <tidy-card
          class="card-checkbox"
          [ngClass]="{'selected-card-checkbox': template.isSelected}"
          (click)="selectTemplate(template)">
          <div style="display: flex; align-items: center">
            <tidy-text [header]="template?.name" />
          </div>
          <tidy-row>
            <tidy-text [body]="template?.description" />
          </tidy-row>
        </tidy-card>
      }
    </tidy-row>

    <tidy-button
      [text]="'Save Inspection Settings'"
      [action]="boundSave"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
